<template>
  <GenericCard
    :locked="locked"
    has-delete
    :subtitle="subtitle"
    :on-delete="onCardDelete"
    :on-action="submitForm"
    :on-refresh="onCardRefresh"
    :invalid="$v.section.$invalid"
    :dirty="$v.section.$anyDirty"
    :create="create"
    title="AKA"
    :section="section"
    has-footer
    has-share
    :card-identifier="cardIdentifier"
    :survey-validation="surveyValidation"
    :survey-identifier="surveyIdentifier"
  >
    <v-form
      :disabled="locked"
      @submit.prevent="submitForm"
    >
      <v-row>
        <v-col>
          <v-text-field
            v-model="section.name"
            autocomplete="off"
            label="Name*"
            outlined
            :error-messages="getErrorMessages($v.section.name)"
            @input="$v.section.name.$touch()"
            @blur="$v.section.name.$touch()"
          />
        </v-col>
        <v-col>
          <v-text-field
            v-model="section.notes"
            autocomplete="off"
            label="Notes"
            outlined
            :error-messages="getErrorMessages($v.section.notes)"
            @input="$v.section.notes.$touch()"
            @blur="$v.section.notes.$touch()"
          />
        </v-col>
      </v-row>
    </v-form>
  </GenericCard>
</template>

<script>
import { helpers, required } from '@vuelidate/validators'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { useVuelidate } from '@vuelidate/core'

import { PARTY_NAMESPACE } from '@/store/party'
import { alertHandler } from '@/alertHandler'

import GenericCard from '@/components/Party/PartyEdit/SectionCards/GenericCard'

export default {
  name: 'AKACard',
  components: { GenericCard },

  props: {
    item: {
      type: Object,
      required: true,
    },

    surveyIdentifier: {
      type: String,
      default: null,
    },

    surveyValidation: {
      type: Boolean,
      default: false,
    },
  },

  setup () {
    return {
      $v: useVuelidate(),
      ...alertHandler(),
    }
  },

  data () {
    return {
      section: {},
    }
  },

  validations () {
    return {
      section: {
        name: { required: helpers.withMessage('Name is required', required) },
        notes: {},
      },
    }
  },

  computed: {
    cardIdentifier () { return `aka-card-${this.sectionIdentifier}` },
    create () { return this.item.id === null },

    locked: {
      get () {
        return this.peAKACardLock(this.sectionIdentifier)
      },

      set (value) {
        this.setPeAKACardLock({ index: this.sectionIdentifier, locked: value })
      },
    },

    sectionIdentifier () { return this.section.id || 'new' },

    subtitle () {
      if (this.create) return ''
      return `(${this.section.name})`
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peAKACardLock',
    ]),
  },

  watch: {
    item: {
      immediate: true,

      handler: function () {
        this.section = { ...this.item }
      },

      deep: true,
    },
  },

  created () {
    if (!this.create) this.initPeAKACard(this.sectionIdentifier)
  },

  methods: {
    getErrorMessages (validator) { return validator?.$errors.map(e => e.$message) },

    async onCardCreate () {
      return this.peAKACardCreate({ index: this.sectionIdentifier, section: this.section })
    },

    async onCardDelete () {
      if (this.create) return this.peAKACardCreateUndo()
      else {
        return this.peAKACardDelete({ id: this.section.id, index: this.sectionIdentifier })
      }
    },

    async onCardRefresh () {
      return this.peAKACardRefresh({ index: this.sectionIdentifier, section: this.section })
    },

    async onCardUpdate () {
      return this.peAKACardUpdate({ id: this.section.id, index: this.sectionIdentifier, section: this.section })
    },

    async onSectionUnlock () {
      return this.setPeAKACardLock({ index: this.sectionIdentifier, locked: false })
    },

    async submitForm () {
      if (this.locked) return this.onSectionUnlock()
      else if (this.create) return this.onCardCreate()
      else return this.onCardUpdate()
    },

    ...mapMutations(PARTY_NAMESPACE, [
      'peAKACardCreateUndo',
      'setPeAKACardLock',

    ]),

    ...mapActions(PARTY_NAMESPACE, [
      'initPeAKACard',
      'peAKACardCreate',
      'peAKACardDelete',
      'peAKACardRefresh',
      'peAKACardUpdate',
    ]),
  },
}
</script>
